import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import Cell from "../../Cell/Cell";

export const DreamNoteIcon = ({ dream }: { dream: IDream }) => {
    if (dream.notes === "") {
        return null;
    }

    return (
        <Cell>
            <span data-tip={`Notes: ${dream.notes}`}>
                <Glyphicon icon={EGlyphicon.pencil} />
            </span>
        </Cell>
    );
};
